jQuery(window).ready(function($){
    function doResize() {
        calculateSectionBounds();
        doScroll();
    }
    function doScroll() {
        var scrollPos = parseInt($(window).scrollTop());
        checkActiveSection(scrollPos);
    }
    function calculateSectionBounds() {
        $.each($('.section-group'), function() {
            var top = $(this).offset().top;
            var bottom = top + $(this).outerHeight();
            $(this).attr('data-top', top);
            $(this).attr('data-bottom', bottom);
        });
        $.each($('.page'), function() {
            var top = $(this).offset().top;
            var bottom = top + $(this).outerHeight();
            $(this).attr('data-top', top);
            $(this).attr('data-bottom', bottom);
        });
    }
    function checkActiveSection(scrollPos) {
        $.each($('.section-group'), function() {
            var top = parseInt($(this).attr('data-top'));
            var bottom = parseInt($(this).attr('data-bottom'));
            if (scrollPos > top && scrollPos < bottom) {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    setActiveSectionTitle($(this).data('label'), $(this).data('label'));
                    $(window).trigger('section|change', [$(this).attr('id')]);
                }
            } else {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    setActiveSectionTitle('', $(this).data('label'));
                    $(window).trigger('section|change', [$(this).attr('id')]);
                }
            }
        });
        $.each($('.page'), function() {
            var top = parseInt($(this).attr('data-top'));
            var bottom = parseInt($(this).attr('data-bottom'));
            if (scrollPos >= top && scrollPos < bottom) {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(window).trigger('page|change', [$(this).attr('id')]);
                }
            } else {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                }
            }
        });
    }
    function setActiveSectionTitle(label, labelcheck) {
        var current = $('#section-label').html();
        if (typeof(labelcheck) === 'undefined') { labelcheck = ''; }
        if ((label !== '' && label !== current) || ((label === '') && (labelcheck === current))) {
            // only set label to blank if it equals the current section asking for the clear
            $('#section-label').html(label);
        }
    }
    //
    // HANDLE SMOOTH SCROLL
    $('.smooth').on('click', function(e) {
        e.preventDefault();
        $('#hide-menu').click();
        smoothScrollToPage($(this).attr('href'));
    });
    //
    // PAGE NAV
    var pages = [];
    var sections = [];
    // make sure each page has an id
    $.each($('.page'), function(i) {
        var id = $(this).attr('id');
        if (typeof(id) !== 'string' || id === 'undefined') {
            $(this).attr('id', 'page-' + i);
        }
        pages.push($(this).attr('id'));
    });
    // make sure each section has an id
    $.each($('.section-group'), function(i) {
        var id = $(this).attr('id');
        if (typeof(id) !== 'string' || id === 'undefined') {
            $(this).attr('id', 'section-' + i);
        }
        sections.push($(this).attr('id'));
    });
    function handleChangedPage(e, pageId) {
        $("#prev-page").off('click', handlePrevPage);
        $("#next-page").off('click', handleNextPage);
        $("#top-page").off('click', handleTopPage);
        $("#bottom-page").off('click', handleBottomPage);
        for (var i = 0; i < pages.length; i++) {
            if (pages[i] === pageId) {
                if (i < pages.length - 1) {
                    $("#bottom-page").on('click', handleBottomPage);
                    $("#bottom-page").removeClass('disabled');
                    $("#next-page").on('click', handleNextPage);
                    $("#next-page").removeClass('disabled');
                } else {
                    $("#next-page").addClass('disabled');
                    $("#bottom-page").addClass('disabled');
                }
                if (i > 0) {
                    $("#top-page").on('click', handleTopPage);
                    $("#top-page").removeClass('disabled');
                    $("#prev-page").on('click', handlePrevPage);
                    $("#prev-page").removeClass('disabled');
                } else {
                    $("#top-page").addClass('disabled');
                    $("#prev-page").addClass('disabled');
                }
            }
        }
    }
    function handleTopPage(e) {
        handlePrevSection(e);
    }
    function handleBottomPage(e) {
        handleNextSection(e);
    }
    function handleNextSection(e) {
        e.preventDefault();
        var current = sections.indexOf($('.section-group.active').attr('id') ? $('.section-group.active').attr('id') : $('.section-group').attr('id'));
        if (current >= 0 && current < sections.length - 1) { smoothScrollToPage(sections[current+1]); }
        if (current >= sections.length - 1) { smoothScrollToPage(pages[pages.length - 1]); } // scroll to end if we are in the last section
    }
    function handlePrevSection(e) {
        e.preventDefault();
        var current = sections.indexOf($('.section-group.active').attr('id') ? $('.section-group.active').attr('id') : $('.section-group').attr('id'));
        if (current > 0 && current <= sections.length - 1) { smoothScrollToPage(sections[current-1]); }
        if (current <= 0) { smoothScrollToPage(pages[0]); } // scroll to beginning if we are in the first section
    }
    function handleNextPage(e) {
        e.preventDefault();
        var current = pages.indexOf($('.page.active').attr('id') ? $('.page.active').attr('id') : $('.page').attr('id'));
        if (current >= 0 && current < pages.length - 1) { smoothScrollToPage(pages[current+1]); }
    }
    function handlePrevPage(e) {
        e.preventDefault();
        var current = pages.indexOf($('.page.active').attr('id') ? $('.page.active').attr('id') : $('.page').attr('id'));
        if (current > 0 && current <= pages.length - 1) { smoothScrollToPage(pages[current-1]); }
    }
    function smoothScrollToPage(id) {
        if (id.indexOf('#') !== 0) {
            id = '#' + id;
        }
        $('html, body').animate({
            scrollTop: $( id ).offset().top + 10
        }, 1000);
    }
    //
    function loadVideoByBreakpoint() {
        var videoEmbed = 'https://player.vimeo.com/video/||REPLACE||?autoplay=1&loop=0&color=c10230&title=0&byline=0&portrait=0&background=1&muted=1';
        var video = $('#intro iframe');
        var id = '';
        if (Foundation.MediaQuery.is('small only')) {
            id = parseInt($(video).attr('data-small'));
            $(video).parent().addClass('mobile');
        } else {
            id = parseInt($(video).attr('data-large'));
            $(video).parent().removeClass('mobile');
        }
        $(video).attr('src', videoEmbed.replace('||REPLACE||', id));
    }
    //
    $("#helper-nav").addClass('active');
    $('.animate').scrolla( {
        mobile: true, // disable animation on mobiles 
        once: false // only once animation play on scroll
    });
    $(window).on('page|change', handleChangedPage);
    $(window).on('scroll', doScroll);
    $(window).on('resize', doResize).resize();
    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
        if (newSize === 'small' || oldSize === 'small') {
            // we need to update the video if we either changed to mobile, or are leaving mobile
            loadVideoByBreakpoint();
			$('.animate').addClass('.animated');
        }
    });
    loadVideoByBreakpoint();
    
    // Lazy load images
    if (typeof($('.lazy').Lazy) === 'function') {
        $('.lazy').Lazy({
            scrollDirection: 'vertical',
            effect: 'fadeIn',
            visibleOnly: true
        });
    }
    //
    $('#show-menu').on('click', function(e) {
        e.preventDefault();
        $('#nav-overlay').addClass('active');
    });
    $('#hide-menu').on('click', function(e) {
        e.preventDefault();
        $('#nav-overlay').removeClass('active');
    });
});